import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const 	GET_WX_MATERIAL = "/api/getMaterials" //获取素材
export default {
	getMaterials: async({
		commit,
	}, params={}) => {
		try{
			const data = await http.get(GET_WX_MATERIAL,params)
			switch (params.type){
				case 'news':
					commit('NEWS', data)
					break;
				case 'image':
					commit('IMAGE', data)
					break;
				case 'video':
					commit('VIDEO', data)
					break;
				case 'voice':
					commit('VOICE', data)
					break;	
				default:
					break;
			}
		}catch(e){
			throw e;
		}
		
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/material/actions.js